import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { CATEGORY_COLORS, fmtMoney } from "@/lib/theme";

// Stable references so recharts children don't re-render every frame.
const CHART_MARGIN = { top: 20, right: 8, left: 8, bottom: 4 };
const AXIS_TICK = { fill: "#94A3B8", fontSize: 11 };
const AXIS_LINE = { stroke: "#1E293B" };
const TOOLTIP_CURSOR = { fill: "rgba(255,255,255,0.04)" };

function ChartTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  const d = payload[0].payload;
  return (
    <div className="rounded-lg border border-rig-borderStrong bg-rig-surface2 px-3 py-2 shadow-xl">
      <div className="font-display text-xs uppercase tracking-widest text-rig-dim">{d.category}</div>
      <div className="font-display text-lg font-bold text-white">{fmtMoney(d.total)}</div>
    </div>
  );
}

export function CategoryChart({ data, height = 220 }) {
  const hasData = data.some((d) => d.total > 0);
  return (
    <div className="rounded-2xl border border-rig-border bg-rig-surface p-5">
      {!hasData ? (
        <div className="flex h-[180px] flex-col items-center justify-center text-center">
          <div className="text-sm text-rig-dim">No spend logged this month yet.</div>
          <div className="mt-1 text-xs text-rig-mute">Add a receipt to see your category breakdown.</div>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={height}>
          <BarChart data={data} margin={CHART_MARGIN}>
            <XAxis
              dataKey="category"
              tick={AXIS_TICK}
              axisLine={AXIS_LINE}
              tickLine={false}
            />
            <Tooltip cursor={TOOLTIP_CURSOR} content={<ChartTooltip />} />
            <Bar dataKey="total" radius={[6, 6, 0, 0]} maxBarSize={54}>
              {data.map((d) => (
                <Cell key={d.category} fill={CATEGORY_COLORS[d.category] || "#94A3B8"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
